import React from "react"
import styled from "styled-components"

import FlotaCard from "./FlotaCard"
import Title from "./Title"

const Flota = () => {
  return (
    <Container className="section">
      <Title title="tarifas" subtitle="autos increibles a precios increibles" />
      <FlotaCard />
    </Container>
  )
}

const Container = styled.section`
  background: var(--white);
`

export default Flota
